/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, forwardRef, Input, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ReactiveFormHelperService } from 'app/shared/helpers/reactive-form-helper.service';
import { TicketPriceTypeModel } from 'app/shared/models/ticket-price-type.model';
import { SnackBarService } from 'app/shared/services/snack-bar.service';
import { FormAddListBase } from '../form-add-list-base/form-add-list-base.component';

const customValueProvider = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => TicketPriceTypeAddListComponent),
	multi: true,
};
const customValidateProvider = {
	provide: NG_VALIDATORS,
	useExisting: forwardRef(() => TicketPriceTypeAddListComponent),
	multi: true,
};
@Component({
	selector: 'ticket-price-type-add-list',
	templateUrl: './ticket-price-type-add-list.component.html',
	styleUrls: ['./ticket-price-type-add-list.component.scss'],
	providers: [customValueProvider, customValidateProvider],
	standalone: false,
})
export class TicketPriceTypeAddListComponent extends FormAddListBase<TicketPriceTypeModel> {
	@Input() lookupData: any[] = []; // this is the ticket price type lookup data
	@Input() dropdownWidthPx: number = 837; // default width for dropdown, can  be overridden for different width controls
	@Input() title: string = 'Additional Actions'; // title for the component
	@Input() allowReorder: boolean = false; // flag to enable/disable reordering

	constructor(protected fb: FormBuilder, protected formHelperService: ReactiveFormHelperService, protected snackBar: SnackBarService, protected dialog: MatDialog) {
		super(fb, formHelperService, snackBar, dialog);
	}

	// shortcuts to controls for readability
	ticketPriceTypeId(index: number): AbstractControl {
		return this.control(index, 'ticketPriceTypeId');
	}

	private control(index: number, fieldName: string) {
		let control: AbstractControl;
		control = this.itemArray.controls[index].get(fieldName);
		return control;
	}

	protected createBlankItem() {
		const row: TicketPriceTypeModel = {
			id: this.nextId--,
			ticketPriceTypeId: null,
			ordinal: 0,
			canDelete: true,
		};
		return row;
	}
	protected createFormGroupForRowItem(row: TicketPriceTypeModel): FormGroup<any> {
		const formGroup = this.fb.group({
			id: [row.id],
			ticketPriceTypeId: [row.ticketPriceTypeId, [Validators.required]],
			ordinal: [row.ordinal],
			canDelete: [true],
		});

		return formGroup;
	}

	ngAfterViewInit() {
		document.body.style.setProperty('--ticket-price-type-dropdown-width', `${this.dropdownWidthPx}px`);
	}

	ngOnChanges(change: SimpleChanges) {
		if (change.lookupData) {
			//check each row item, if it has a ticketPriceTypeId that is not in the lookupData, remove it
			this.itemArray.controls.forEach((item, index) => {
				const ticketPriceTypeId = item.get('ticketPriceTypeId').value;
				if (!this.lookupData.some((data) => data.id === ticketPriceTypeId)) {
					// remove the items ticketPriceTypeId if it is not in the lookupData, to apply required validation
					item.get('ticketPriceTypeId').setValue(null);
				}
			});
		}
	}
}
